import "./PopupComponent.css";

interface Props {
  confirmAction: () => void | Promise<void>;
  confirmText: string;
  closeAction: () => void | Promise<void>;
  closeText: string;
  title: string;
  message: string;
}

function PopupComponent({
  confirmAction,
  confirmText,
  closeAction,
  closeText,
  title,
  message,
}: Props) {
  return (
    <>
      <div className="popup-overlay">
        <div className="popup">
          <div className="popup-title">{title}</div>
          <div className="popup-message">{message}</div>

          <div className="popup-actions">
            <button className="popup-btn popup-btn-secondary" onClick={closeAction}>
              {closeText}
            </button>
            <button className="popup-btn popup-btn-primary" onClick={confirmAction}>
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default PopupComponent;
